(() => {
  const SEARCH_PATH_REGEX = /\/search\/?$/;
  const SKU_LIKE_REGEX = /^[a-z0-9_-]{3,}$/i;

  const isSearchForm = (form) => {
    if (!form || form.method.toLowerCase() !== 'get') return false;

    const action = new URL(form.action, window.location.origin);
    return SEARCH_PATH_REGEX.test(action.pathname);
  };

  const ensurePrefixOption = (form) => {
    let prefixInput = form.querySelector('input[name="options[prefix]"]');

    if (!prefixInput) {
      prefixInput = document.createElement('input');
      prefixInput.type = 'hidden';
      prefixInput.name = 'options[prefix]';
      form.append(prefixInput);
    }

    prefixInput.value = 'last';
  };

  const normalizeSearchQuery = (form) => {
    const queryInput = form.querySelector('input[name="q"]');
    if (!queryInput) return;

    const query = queryInput.value.trim();
    if (!query) return;

    const isSkuLikePartial = SKU_LIKE_REGEX.test(query) && /\d/.test(query);
    if (isSkuLikePartial && !query.endsWith('*')) {
      queryInput.value = `${query}*`;
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!isSearchForm(form)) return;

      ensurePrefixOption(form);
      normalizeSearchQuery(form);
    },
    true
  );
})();
